<template>
	<div class="clientEmployeeList">
        <div class="o-main-content-area">
            <div class="row c-responsive-fixwidth">
                <div class="col-md-3">
                    <h1 class="h1">Employer</h1>
                </div>
                <div class="col-md-9 text-right">
                    <ul class="o-filter-area">
            
                        <li class="o-search-field">
                            <div class="input-group stylish-input-group">
                                <input @input="getEmployers()" v-model="search_query" type="text" class="form-control" placeholder="Name, email, or phone">
                                <span class="input-group-addon">
                                    <button type="submit">
                                    <span class=""><i class="fa fa-search" aria-hidden="true"></i></span>
                                </button>
                                </span>
                            </div>
                        </li>
                        <li><router-link to="/addEmployerClient" class="c-common-btn c-common-btn--green"><i class="fa fa-plus" aria-hidden="true"></i> Add new Employer</router-link></li>
                    </ul>

                </div>
            </div>
        </div>
        <div class="o-ndividualArea c-responsive-fixwidth">
            <div class="o-ndividualTable">
                <div class="c-common-space o-individual-calls">
                    <div class="col-md-12 o-no-padding">
                        <form class="form-inline">
                            <div class="form-group">
                                <label class="common-label-text">Sort By:</label>
                                <div class="o-cutsomSelect o-cutsomSelect--fixedwidth">
                                    <select  @change="getEmployers()" v-model="selectedShortType">
                                        <option value="fname_asc">FirstLast (Employer name)</option>
                                        <option value="fname_desc">LastFirst (Employer name)</option>
                                        <option value="email">Email</option>
                                    </select>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>

                <div class="o-skills-listing">
                    <div class="row">

                        <div class="col col-sm-12">
                            <div 
                                class="o-scheduleTable--daily" 
                                infinite-scroll-disabled="busy" 
                                infinite-scroll-distance="10"
                                v-loading="loading" 
                                v-infinite-scroll="{ handler: handleScroll, distance: 10 }"
                                ref="scrollContainer"
                                style="min-height: 1px;overflow:auto;"
                            >
                                <div 
                                    v-for="employer in employerList" :key="employer.id" 
                                    class="o-calls-table c-common-gradient c-common-box-shadow c-radius3 c-margin-bottom-10 employer-list-table-align"
                                >
                                    <div class="calls-table-row">
                                        <div class="calls-table-cell">
                                            <div class="table-td-border-right">
                                                <div @click ="goToEmployerDetails(employer.id)" class="calls-table-cell-inner-table o-modal-trigger" data-toggle="modal" data-target="#employeeSummaryModal">
                                                    <div class="o-accordion-subtext user-icon">
                                                        <div class="o-post-logged o-post-logged--table-user">
                                                            <div class="o-user-profile-img">
                                                                <img v-if="employer.image=='' || employer.image==null" src="static/assets/images/user1.png">
                                                                <img v-else :src="employer.image">
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="o-accordion-subtext o-rowtable-text">
                                                        <span>Name</span>
                                                        <div>{{employer? employer.name:''}}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="calls-table-cell">
                                            <div class="table-td-border-right employer-user-list-scroll">
                                                <div class="calls-table-cell-inner-table">
                                                    <div class="o-accordion-subtext o-rowtable-text">
                                                        <span>Contact:</span>
                                                        <div v-for="(user,userIndex) in employer.employer_users" :key="userIndex">{{user.user ? user.user.first_name : ''}}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>                                        
                                        <div class="calls-table-cell">
                                            <div class="table-td-border-right">
                                                <div class="o-accordion-subtext o-rowtable-text">
                                                    <span>Email ID:</span>
                                                    <div>{{employer ? employer.email:''}}</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="calls-table-cell">
                                            <div class="table-td-border-right">
                                                <div class="calls-table-cell-inner-table">
                                                    <div class="o-accordion-subtext o-rowtable-text">
                                                        <span>Billed Users:</span>
                                                        <div>{{ employer.employer_users.length-1 }}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="calls-table-cell">
                                            <div class="table-td-border-right">
                                                <div class="o-accordion-subtext o-rowtable-text">
                                                    <span>Phone:</span>
                                                    <div v-for="(phone,phIndex) in employer.phones" :key="phIndex" v-if="phone.label!='Fax'">
                                                        <a :href="'tel:'+getClientContactFormat(phone.phone_number)" class="phone-number-display">
                                                            {{ phone.phone_number ? getClientContactFormat(phone.phone_number) : '' }}
                                                        </a>
                                                        <!-- {{phone.phone_number?phone.phone_number:''}} -->
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="calls-table-cell">
                                            <div class="table-td-border-right">
                                                <div class="o-accordion-subtext o-rowtable-text">
                                                    <span>FAX:</span>
                                                    <div v-for="(phone,phIndex) in employer.phones" :key="phIndex" v-if="phone.label == 'Fax'">
                                                        <a :href="'tel:'+getClientContactFormat(phone.phone_number)" class="phone-number-display">
                                                            {{ phone.phone_number ? getClientContactFormat(phone.phone_number) : '' }}
                                                        </a>
                                                        <!-- {{phone.phone_number?phone.phone_number:''}} -->
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="calls-table-cell">
                                            <div class="table-td-border-right">
                                                <div class="o-accordion-subtext o-rowtable-text o-notify-cell">
                                                    <span class="">Notify</span>
                                                    <div class="notify-icon"><i class="fa fa-mobile" aria-hidden="true"></i></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="calls-table-cell">
                                            <div class="">
                                                <div class="o-accordion-subtext o-rowtable-text o-notify-cell">
                                                    <span class="">View</span>
                                                    <a class="notify-icon" :href="goToLogin(employer.id)" target="_blank"><i class="fa fa-eye" aria-hidden="true"></i></a>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="calls-table-cell text-center o-no-padding">
                                            <div class="o-edit-trash o-no-padding">

                                                <div class="o-table-block-btn">
                                                    <router-link :to="'/editEmployerClient/'+getId(employer.id)"><i class="fa fa-pencil" aria-hidden="true"></i></router-link>
                                                </div>
                                                <div class="o-table-block-btn">
                                                    <a href="javascript: void(0)" @click="deleteEmployer(employer.id)"><i class="fa fa-trash-o" aria-hidden="true"></i></a>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="employerList.length <= 0 && !loading" class="c-common-space c-common-gradient c-common-box-shadow c-radius3">
                                   <div class="col-md-12 no-job-dispaly">
                                      <i class="fa fa-frown-o" aria-hidden="true"></i>
                                      <br />
                                       No Data Stored
                                   </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
	</div>
</template>
<script>
    import dateTimeConvert from '../../../timeConvert&Compare';
    import {mapGetters, mapActions} from 'vuex';
    import service from '../../../services.js';
    import {global} from '../../../global.js';
    export default {
        data() {
            return {
                employerList:[],
                selectedShortType:'fname_asc',
                search_query:'',
                loading:true,
                savedEmployees:[],
                next_page:'',
            }
        },
        computed: {
            ...mapGetters({
                userToken: 'userToken',
            })
        },
        methods: {
            getClientContactFormat(phone) {
                phone = phone ? phone.toString() : '';
                
                let result = '';
                if(phone&&phone.length==10) { 
                    result = '+1'+phone;
                }else if(phone&&phone.length==11) {
                    result = '+' + phone;
                }else if(phone&&phone.length) {
                    result = phone;
                }
                return result;
            },
            getId(id){
                return btoa(id);
            },
            goToEmployerDetails(id){
                this.$router.push({
                    'path': '/employerDetailsClient/'+btoa(id)
                });
            },
            getEmployers(){
                this.employerList=[];
                this.savedEmployees =[];
                this.loading=true;
                service.get('employer', {
                    'Authorization': this.userToken,
                    'sort': this.selectedShortType,
                    'search': this.search_query,
                    'pagination': 1
                }).then((res) => {
                    this.loading=false;
                    this.employerList = res.data.result.data;
                    this.next_page = res.data.result.next_page_url;
                    if (this.next_page != null || this.next_page != "") {
                        service.getUrl(this.next_page, {
                            'Authorization': this.userToken,
                            'sort': this.selectedShortType,
                            'search': this.search_query,
                            'pagination': 1
                        }).then((res) => {
                            this.savedEmployees = res.data.result.data;
                            this.next_page = res.data.result.next_page_url;

                        }).catch((err) => {
                            console.log(err);
                        });
                    } 
                }).catch((err) => {
                    this.loading=false;
                    console.log('error',err);
                    this.$message({
                        type: 'error',
                        message: 'Sorry, Something Went Wrong: Please try again later.'
                    });
                });   
            },

            async handleScroll() {
                if (position !== "bottom") return; 
                await this.loadMore();
            },

            async loadMore() {
                var arr = this.employerList;
                if (this.savedEmployees.length != 0) {
                    this.savedEmployees.forEach(function(entry) {
                        arr.push(entry);
                    })
                    this.savedEmployees=[];
                    if (this.next_page != null || this.next_page != "") {
                        await service.getUrl(this.next_page, {
                            'Authorization': this.userToken,
                            'sort': this.selectedShortType,
                            'search': this.search_query,
                            'pagination': 1
                        }).then((res) => {
                            this.savedEmployees = res.data.result.data;
                            this.next_page = res.data.result.next_page_url;

                        }).catch((err) => {
                            console.log(err);
                        });
                    }else
                        this.savedEmployees = [];
                }
                this.$nextTick(() => {
                    if (this.$refs.scrollContainer && this.$refs.scrollContainer._checkScroll) {
                        this.$refs.scrollContainer._checkScroll();
                    }
                });

            },
            deleteEmployer(id){
                this.$confirm('This will permanently delete the file. Continue?', 'Warning', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    this.loading=true;
                    service.del('employer/'+id, {
                        'Authorization': this.userToken
                    }).then((res) => {
                        this.getEmployers();
                        this.$message({
                            type: 'success',
                            message: 'Employer deleted.'
                        });
                    }).catch((err) => {
                        this.loading=false;
                        this.$message({
                            type: 'error',
                            message: 'Sorry, Something Went Wrong: Please try again later.'
                        });
                    }); 
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: 'Delete canceled'
                    });
                });
            },
            goToLogin(employerId) {
                let url="http://labour." +global[0].CLIENT_BASE+"#/login/employer/"+btoa(employerId)+"/"+btoa(this.userToken);
                return url;
            }   
       	},
        mounted() {},
        created() {
            this.getEmployers();
        }
    }

</script>
<style scoped>
.phone-number-display{
    padding: 5px;
    cursor: pointer;
    color: #222222;
    text-decoration: none !important;
}
.employer-user-list-scroll{
    overflow-y: scroll;
    max-height: 78px;
}

</style>
